<!-- Ship Profiles -->
<div *ngIf="!registarMode">
  <div>
    <div class="card card-nc" *ngIf="hasEntitlement('SEARCH_SHIP')">
      <div class="card-heading">
        <span class="cardHeaderHeading"> Fleet Health </span>
      </div>
      <div class="card-body" *ngIf="alertShips.size > 0">
        <p class="text-justify" style="font-size: large">
          <strong class="red-text">ALERT:</strong> {{fleetAlert}}
        </p>
        <div>
          <div
            *ngFor="
            let shipAlert of alertShips | keyvalue
          ">
            <div style="font-size: medium; padding: 4px">
              <strong>{{shipAlert.key}}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="card card-nc" *ngIf="hasEntitlement('SEARCH_SHIP')">
      <div class="card-heading">
        <span class="cardHeaderHeading"> Ship Profiles </span>
      </div>
      <div class="card-body">
        <form #searchForm="ngForm" class="" name="userSearchForm" novalidate>
          <div class="row">
            <div class="col-md-11">
              <app-dropdown-select-control
                *ngIf="ships"
                (keyup.enter)="onSearchEnter($event)"
                classes="form-control input-sm searhBoxheight"
                elementId="location"
                suppressSearch="true"
                placeholder="Select ship location."
                [searchTerm]="newSearchTerm"
                [source]="ships"
                (valueSelected)="selectLocation($event)"
              >
              </app-dropdown-select-control>
            </div>
            <div class="col-md-1">
              <button
                #searchButton
                type="submit"
                (click)="onSearchClick()"
                class="form-group btn btn-nc pull-right"
              >
                SEARCH
                <i [ngClass]="{ 'fa fa-spinner fa-spin': processing }"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div *ngIf="hasEntitlement('SEARCH_SHIP')" [ngSwitch]="whichView">
    <div *ngSwitchCase="'none'" class="row justify-content-center">
      <div *ngIf="processing" class="col-1">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
    </div>
    <div *ngSwitchCase="'noResults'">
      <div class="searchResults">
        <div class="row searchResultsRow">No results found.</div>
      </div>
    </div>
    <div
      *ngIf="searchResults && searchResults.length > 0"
      class="searchResults"
    >
      <app-ship-search-results
        (shipSelected)="shipSelected($event)"
        *ngSwitchCase="'searchResults'"
        [results]="searchResults"
      >
      </app-ship-search-results>
    </div>
    <div *ngIf="results && results.length > 0" class="searchResults">
      <app-ship-search-results
        (shipSelected)="shipSelected($event)"
        *ngSwitchCase="'results'"
        [results]="results"
      >
      </app-ship-search-results>
    </div>
    <div *ngIf="pendingShips && pendingShips.length > 0" class="searchResults">
      <app-ship-search-results
        *ngSwitchCase="'pendingShips'"
        [results]="pendingShips"
      >
      </app-ship-search-results>
    </div>
  </div>
  <br />
  <!-- Register New Ship -->
  <div *ngIf="hasEntitlement('REGISTER_SHIP')">
    <!-- remove false once we are ready to expose feature -->
    <div class="card card-nc">
      <div class="card-heading">
        <span class="cardHeaderHeading"> Register New Ship </span>
      </div>
      <div class="card-body">
        <form #searchForm="ngForm" class="" name="userSearchForm" novalidate>
          <div class="row">
            <div class="col-md-11"></div>
            <div class="col-md-1">
              <button
                type="submit"
                (click)="onRegisterClick()"
                class="form-group btn btn-nc pull-right"
              >
                Register<i
                  [ngClass]="{ 'fa fa-spinner fa-spin': processing }"
                ></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Sync a pending ship -->
  <div
    *ngIf="hasEntitlement('REGISTER_SHIP')"
    [ngSwitch]="whichPendingShipView"
  >
    <app-ship-pending></app-ship-pending>
  </div>
</div>
<div *ngIf="registarMode">
  <app-ship-register (registerCancel)="registarMode = false">
  </app-ship-register>
</div>
